import { FAILED_URL, SUCCESS_URL } from '../config/constants';
import httpClient, { resolve } from './httpClient';

export const getHomeCourses = async (page = 1) => {
  return await resolve(
    await httpClient.get('home/view', {
      params: {
        page: page,
      },
    })
  );
};

export const getCourseDetails = async (courseId) => {
  return await resolve(await httpClient.get(`home/detail/${courseId}`));
};

export const applyPromoCode = async ({ courseId, promoCode }) => {
  return await resolve(
    await httpClient.post(`home/applypromocode`, {
      courseId: courseId,
      promoCode: promoCode,
    })
  );
};

export const bookNow = async (
  courseId,
  name,
  email,
  phone,
  preferredDate,
  promoCodeValidity = '0',
  promoId,
  promoCode,
  discountAmount,
  amount
) => {
  const body = {
    courseId: courseId,
    name: name,
    email: email,
    phone: phone,
    preferredDate: preferredDate,
    amount: amount,
    callbackUrl: SUCCESS_URL,
    errorUrl: FAILED_URL,
    promocodeValidity: '0',
  };

  if (promoId) {
    body.promocodeValidity = promoCodeValidity;
    body.promoId = promoId;
    body.promoCode = promoCode;
    body.discountamount = discountAmount;
  }
  return await resolve(await httpClient.post(`course/book`, body));
};

export const bookingSuccess = async ({
  bookingId,
  paymentId,
  bookingPaymentId,
  gatewayId,
  uResult,
  uPostDate,
  uRef,
  uTrackId,
  uOrderId,
  uAuth,
  uTranId,
}) => {
  const additionalDetails = {};
  if (gatewayId == 2) {
    additionalDetails['Result'] = uResult;
    additionalDetails['PaymentID'] = paymentId;
    additionalDetails['PostDate'] = uPostDate;
    additionalDetails['Ref'] = uRef;
    additionalDetails['TrackID'] = uTrackId;
    additionalDetails['OrderID'] = uOrderId;
    additionalDetails['Auth'] = uAuth;
    additionalDetails['TranID'] = uTranId;
  } else if (gatewayId == 1) {
    additionalDetails['paymentId'] = paymentId;
  }
  return await resolve(
    await httpClient.post(`course/success`, {
      bookingId,
      bookingPaymentId,
      gatewayId,
      ...additionalDetails,
    })
  );
};

export const sendMail = async (bookingId, email) => {
  return await resolve(
    await httpClient.post(`course/sentmail`, {
      bookingId,
      email,
    })
  );
};
